import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import Button from 'react-bootstrap/Button';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ReactImageFallback from 'react-image-fallback';
import { createNotification } from 'react-redux-notify';

import Location from '../../common/Location';
import PrimaryButton from "../../Buttons/PrimaryButton";
import { utilitiesServiceUrl } from '../../../helpers/constants/api';
import UserConstantsHelper from '../../../helpers/constants/user';
import { getErrorNotificationMessage } from '../../helper/NotificationMessage';

import MailIconV2 from '../../../images/icons/mail-icon-v2.svg?react';
import CallIconV2 from '../../../images/icons/call-icon-v2.svg?react';
import FollowIconV2 from '../../../images/icons/follow-icon-v2.svg?react';

const location = "https://d9apl513jlx0u.cloudfront.net/public_assets/src/images/login/location.png";
const defaultProfile = 'https://d9apl513jlx0u.cloudfront.net/public_assets/src/images/default/profile_placeholder.jpg'

const CommunityPerformers = ({
  isProcessed,
  setIsProcessed
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [records, setRecords] = useState([]);

  useEffect(() => {
    fetchRecords();
  }, [])

  const fetchRecords = async () => {
    try {
      const response = await fetch(`${utilitiesServiceUrl}landing-page/performers`);
      const data = await response.json();
      setRecords(data);
    } catch (error) {
      console.error('Fetching community performers error', error);
      dispatch(createNotification(getErrorNotificationMessage('Unable to fetch community performers.')));
    }
  };

  // Hide component if no performers
  if (records.length === 0) return <></>

  return (
    <div className='community-main'>
      <div className='container'>
        <div className='heading-box text-center'>
          <div className='section-title'>JOIN OUR COMMUNITY</div>
          <div className='heading-title'>Our performer Community</div>
        </div>
        <div className='row g-3 row-cols-lg-4 row-cols-md-3 row-cols-sm-2 row-cols-1'>
          {records.map((performer, index) => {
            return (
              <div className='col' key={performer.id}>
                <div key={index} className='flip-card'>
                  <div className='flip-card-inner'>
                    <div className='flip-card-front'>
                      <img src={performer.picture} alt='Avatar' />
                      <div className='username-box'>
                        <span
                          className={performer?.online_status === 'online' ? '' : 'user-ofline'}
                        ></span>
                        <p>{performer.username}</p>
                      </div>
                      <div className='location-box'>
                        <img src={location} alt='Location' />
                        <p>
                          {UserConstantsHelper.isUserTraveling(performer)
                            ? performer?.traveling_location
                            : performer?.city && performer?.country
                              ? performer?.city + ', ' + performer?.country
                              : 'Not Available.'}
                        </p>
                      </div>
                    </div>
                    <div className='flip-card-back'>
                      <div className='h-100 d-flex flex-column justify-content-between p-3'>
                        <Link
                          aria-label='navigate to user profile'
                          to={`/user/${encodeURIComponent(performer?.username?.toLowerCase())}`}
                          id='user_suggestion_link'
                        >
                          <div className='search_prof_cont'>
                            <div className='image_round text-center'>
                              <div className='imgprofileoutr'>
                                <ReactImageFallback
                                  src={performer.picture}
                                  fallbackImage={defaultProfile}
                                  alt='Profile image'
                                />
                              </div>
                              <div className='card_porfile_name'>
                                <p className='search-user-name color-white'>{performer.name}</p>
                                <Location
                                  city={performer?.city}
                                  country={performer?.country}
                                  is_traveling={performer?.is_traveling}
                                  traveling_location={performer?.traveling_location}
                                  color='#93999F'
                                  fontSize={16}
                                  locationV2Icon
                                />
                              </div>
                            </div>
                          </div>
                        </Link>
                        <div>
                          <div className='d-flex justify-content-between align-items-center gap-1 mb-1 mb-sm-4'>
                            <Button
                              variant='secondary'
                              style={{
                                backgroundColor: '#E0E4EB',
                                width: '50%',
                                borderRadius: '100px !important',
                                border: 'none',
                                padding: '8px 14px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                              onClick={(event) => {
                                setIsProcessed({
                                  ...isProcessed,
                                  joinNow: true,
                                });
                                setTimeout(() => {
                                  event.preventDefault();
                                  window.scrollTo(0, 0);
                                  navigate('/register');
                                }, 10);
                              }}
                            >
                              <MailIconV2 />
                            </Button>
                            <Button
                              variant='secondary'
                              style={{
                                backgroundColor: '#E0E4EB',
                                width: '50%',
                                borderRadius: '100px !important',
                                border: 'none',
                                padding: '8px 14px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                              onClick={(event) => {
                                setIsProcessed({
                                  ...isProcessed,
                                  joinNow: true,
                                });
                                setTimeout(() => {
                                  event.preventDefault();
                                  window.scrollTo(0, 0);
                                  navigate('/register');
                                }, 10);
                              }}
                            >
                              <FollowIconV2 />
                            </Button>
                          </div>
                          <div>
                            <PrimaryButton
                              className={'w-100 mb-2 btn-customize subscribe-btn-user-card'}
                              onClick={(event) => {
                                setIsProcessed({
                                  ...isProcessed,
                                  joinNow: true,
                                });
                                setTimeout(() => {
                                  event.preventDefault();
                                  window.scrollTo(0, 0);
                                  navigate('/register');
                                }, 10);
                              }}
                              title={`Subscribe`}
                            />
                            <PrimaryButton
                              className={'w-100 mb-2 btn-customize subscribe-btn-user-card'}
                              onClick={(event) => {
                                setIsProcessed({
                                  ...isProcessed,
                                  joinNow: true,
                                });
                                setTimeout(() => {
                                  event.preventDefault();
                                  window.scrollTo(0, 0);
                                  navigate('/register');
                                }, 10);
                              }}
                              title={`Face2Face`}
                              startIcon={CallIconV2}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

CommunityPerformers.propTypes = {
  isProcessed: PropTypes.object,
  setIsProcessed: PropTypes.func,
};

export default CommunityPerformers;
